{
	"common": {
		"text_account_table_header_order": "Knorr-Bremse Bestellnummer",
		"text_warranty_submit_part_mileage": "Mileage in Service*",
		"register_site_description": "Nach Ausfüllen des Anmeldeformulars unten wird Ihr Kontoantrag zur Prüfung vorgelegt_ Sie erhalten eine Bestätigung per E-Mail mit zusätzlichen Anweisungen_",
		"text_warranty_vinNumber_invalid": "Please enter a valid Vehicle ID/VIN-Number/Chassis Number",
		"register_submit": "Jetzt registrieren",
		"login_info": "Register with Bendix and get product availability, pricing, order information, and much more!",
		"text_warranty_submit_date_removed_invalid": "Date Removed from Service can't be less than the Date In Service_",
		"error_account_myPart_part_notcorrect": "Zeile {0} : {1} Artikelnummer {2} wird nicht erkannt und wurde nicht hochgeladen_ Bitte überarbeiten Sie Ihren Eintrag oder wenden Sie sich an Ihren lokalen {3} Kundenservice_",
		"error_account_myPart_part_dublicate": "Line {0} : Part number already used.",
		"text_warranty_search_claim_number": "Bendix Warranty Claim Number",
    "cart_page_req_delivery_date_for_all_items": "Take REQ Depature Date for all positions",
		"error_account_myPart_solto_select": "Bitte Kunde auswählen.",
		"text_warranty_search_part_number": "Bendix Part Number",
		"text_warranty_submit_returning_kbpart_number": "Bendix Part Number (Auto fill)",
		"text_warranty_submit_kb_claim_generated": "Automatically generated by Bendix",
		"checkout_deliveryMethod_notSelected": "Bitte wählen Sie ein Transportunternehmen um den Check-Out Prozess zu vervollständigen_",
		"text_warranty_submit_part_datein_service": "Date in Service*",
		"text_account_warranty_table_header_claim_number": "Knorr-Bremse Gewährleistungsanspruch Nr.",
		"warranty_information": "Bendix Warranty Information Center",
		"header_link_login": "Anmelden/Registrieren",
		"text_core_search_coreGroup": "Enter Core Group",
		"text_warranty_submit_alphanumeric_invalid": "Please enter alphanumeric Number",
		"register_description": "Interested to register with Bendix? Gain access to product pricing and in-store availability, track orders and much more!",
		"text_warranty_search_customer_part_number": "Customer Part Number",
		"text_warranty_submit_part_type_number": "Typ Nummer (wird automatisch gefüllt)",
		"text_warranty_submit_email": "E-Mail-Adresse*",
		"text_core_search_partNumber": "Enter Bendix Part #",
		"error_account_myPart_part_notfound": "Die Artikelnummer ist bereits vorhanden_",
		"text_account_warranty_table_header_dsiplay_status": "Claim Status Reason",
		"text_warranty_claimRefNumber_invalid": "Please enter a valid Claim Number",
		"text_warranty_submit_datein_service_invalid_future": "Date In Service can't be in future date_",
		"text_warranty_submit_phone": "Telefonnummer",
		"text_warranty_submit_kb_claim_number": "Bendix Claim Number",
		"import_csv_savedCart_customerPartNumber": "Customer Part Number(will determine Bendix Part Number)",
		"quick_order_page_req_delivery_date_for_all_items": "All Lines Requested Delivery Date",
		"error_account_myPart_template_select": "Bitte Vorlage auswählen_",
		"text_warranty_submit_returning_part_number": "Returning Part Number*",
		"text_account_warranty_table_header_part_number": "Bendix Part Number",
		"text_warranty_submit_date_removed_service_invalid_future": "Date Removed from Service can't be in future date_",
		"ppd_freight_greater_than_subtotal_info": "Your cart total (exclude core charges) is {0} {1}. You can qualify for prepaid freight if you add {2} {1} worth of parts to your cart_"
	}
}
